const PolicyIcon = ({ size = 24, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g opacity="0.55">
        <path
          d="M21 17.2632H17C16.8674 17.2632 16.7402 17.2133 16.6464 17.1244C16.5527 17.0356 16.5 16.9151 16.5 16.7895V15.3684C16.5 14.7403 16.7634 14.1379 17.2322 13.6937C17.7011 13.2495 18.337 13 19 13C19.663 13 20.2989 13.2495 20.7678 13.6937C21.2366 14.1379 21.5 14.7403 21.5 15.3684V16.7895C21.5 16.9151 21.4473 17.0356 21.3536 17.1244C21.2598 17.2133 21.1326 17.2632 21 17.2632ZM17.5 16.3158H20.5V15.3684C20.5 14.9915 20.342 14.6301 20.0607 14.3636C19.7794 14.0971 19.3978 13.9474 19 13.9474C18.6022 13.9474 18.2206 14.0971 17.9393 14.3636C17.658 14.6301 17.5 14.9915 17.5 15.3684V16.3158Z"
          fill="currentColor"
        />
        <path
          d="M21.5 15.8421H16.5C15.6716 15.8421 15 16.4783 15 17.2632V20.5789C15 21.3638 15.6716 22 16.5 22H21.5C22.3284 22 23 21.3638 23 20.5789V17.2632C23 16.4783 22.3284 15.8421 21.5 15.8421Z"
          fill="currentColor"
        />
      </g>
      <path
        d="M10.6992 2.00098C10.6028 2.00739 10.5138 2.08369 10.5137 2.19727V8.01465C10.5139 8.55874 10.9549 8.99978 11.499 9H18V11H17.293C15.7859 11 14.7491 12.181 14.1826 13.9902C14.107 14.2319 13.9537 14.4435 13.7393 14.5781L13.4688 14.749C13.1774 14.932 13 15.2516 13 15.5957V21H5.36816C4.06024 20.9999 3 19.8901 3 18.5215V4.47852C3 3.1099 4.06024 2.00015 5.36816 2L10.6992 2.00098Z"
        fill="currentColor"
      />
      <path
        opacity="0.3"
        d="M10.5137 8.01424V2.19755C10.5137 2.0219 10.726 1.93394 10.8502 2.05814L17.9415 8.66338C18.0657 8.78758 17.9777 8.99994 17.802 8.99994L11.4994 9C10.955 9 10.5137 8.55866 10.5137 8.01424Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PolicyIcon;
